import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Divider,
  InputBase,
} from "@mui/material";
import SingleChatScreen1 from "../SingleChat/index1";
import { CaseListType } from "../../../../../DataTypes/Case.type";
import CaseApi from "Service/Case.api";
import { UserInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import { FormateCaseList } from "./Formatter";
import ImgPath from "Constants/Imgs";
import DateTime from "Utils/DateTime";
import { disconnectChatHub } from "Service/signalRService";
import NoData from "Components/NoData";
import Loader from "Components/Loader";
import { useMediaQuery, useTheme } from "@mui/material";
import ChatListComponent from "./ChatListComponent";
import ChatWindowComponent from "./ChatWindow";
import { useParams } from "react-router-dom";

const WhatsAppChatListLayout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [selectedCase, setSelectedCase] = useState<null | CaseListType>(null);
  const [showChatList, setShowChatList] = useState(true);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        height: "100%",
        backgroundColor: "#f0f2f5",
        overflow: "hidden",
      }}
    >
      {isMobile ? (
        showChatList ? (
          <ChatListComponent
            setShowChatList={(value: boolean) => setShowChatList(value)}
            getSelectedCase={(caseData: CaseListType) =>
              setSelectedCase(caseData)
            }
          />
        ) : (
          <ChatWindowComponent selectedCase={selectedCase} setShowChatList={setShowChatList} />
        )
      ) : (
        <>
          <ChatListComponent
            setShowChatList={(value: boolean) => setShowChatList(value)}
            getSelectedCase={(caseData: CaseListType) =>
              setSelectedCase(caseData)
            }
          />
          <ChatWindowComponent selectedCase={selectedCase} setShowChatList={setShowChatList} />
        </>
      )}
    </Box>
  );
};

export default WhatsAppChatListLayout;
